<template>
    <div>
        <div class="row" v-if="!accessNewLayout">

            <!-- Notifications -->
            <div class="col-lg-12">
                <trax-ui-card-icon-header class="mt-5" header-color="danger" icon="notifications" :title="lang.polaris.notification.notifications">
                    <trax-notification-widget header="0" searching="0">
                    </trax-notification-widget>
                </trax-ui-card-icon-header>
            </div>

        </div>
        <div class="row" v-else>
            <div class="col-lg-6">

                <!-- Prodecure Notifications -->
                <trax-ui-card-icon-header class="mt-5" header-color="danger" icon="notifications" :title="lang.polaris.dashboard.atp_daf_notifications">
                    <enac-atpl-dashboard-notification-procedure searching="0">
                    </enac-atpl-dashboard-notification-procedure>
                </trax-ui-card-icon-header>

                <enac-atpl-dashboard-notification-procedure-modal>
                </enac-atpl-dashboard-notification-procedure-modal>

            </div>
            <div class="col-lg-6">

                <!-- Other Notifications -->
                <trax-ui-card-icon-header class="mt-5" header-color="danger" icon="notifications" :title="lang.polaris.dashboard.other_notifications">
                    <enac-atpl-dashboard-notification-others searching="0">
                    </enac-atpl-dashboard-notification-others>
                </trax-ui-card-icon-header>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                user: user
            }
        },

        computed: {

            accessNewLayout() {
                return this.user.admin 
                    // || this.user.permissions['dashboard_read_mine_collaborators']
                    || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-mine-locations']
                    || this.user.permissions['dashboard.write-all']
                    ;
            }
        }
    }
</script>
